<template>
    <div>
        <div class="tpl-portlet-components" style="min-height: 460px;padding: 0">
            <div class="tpl-portlet-title" style="margin-bottom: 0">
                <div class="tpl-caption font-blue">

                    <div style="float: left;margin:1px 0 0 60px">
                        <button id="currentMonth" class="view-btn data-btn btn-gradient" v-on:click="selectCurrent">
                            本季
                        </button>
                        <div id="plan-calendar-time-year" class="select-wrap">
                            <el-date-picker
                                    v-model="selectYear"
                                    placeholder="选择年"
                                    size="mini"
                                    style="width: 100px;"
                                    type="year"
                                    @change="changeYear"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!this.isOwner" style=" height: 32px;line-height: 32px;width: 100%;text-align: center;">
                <span style="font-weight: bold;">{{ otherUserName }}</span> 的行动计划
            </div>
            <div class="outer_year_plans_div">
                <swiper ref="mySwiper" :options="swiperOption" class="swiper">
                    <swiper-slide v-for="(quarter,index) in quarterList"
                                  :key="index">
                        <QuarterCard :data="quarter"></QuarterCard>
                    </swiper-slide>
                    <!--                    <div class="swiper-button-prev" slot="button-prev"></div>-->
                    <!--                    <div class="swiper-button-next" slot="button-next"></div>-->
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
import QuarterCard from '@/apps/plan/mobile_page/sub_components/cards/quarter_mobile_card.vue'
import {mapActions, mapGetters, mapState} from 'vuex'
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    name: "year_view",
    components: {
        QuarterCard,
        Swiper,
        SwiperSlide
    },
          props: {
        isOwner: {
            type: Boolean,
            require: true,
        },
          otherUserName: {
            type: String,
            require: true,
        },
          uid:{
            type:String,
             require: true,
          }
    },
    data: function () {
        return {
            swiperOption: {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                on: {
                    init: function () {
                        let newDate = new Date();
                        let theMonth = newDate.getMonth();
                        let quarterIdx = 1;
                        if (theMonth <= 3) {
                            quarterIdx = 1
                        } else if (theMonth <= 6) {
                            quarterIdx = 2
                        } else if (theMonth <= 9) {
                            quarterIdx = 3
                        } else if (theMonth <= 12) {
                            quarterIdx = 4
                        }
                        this.slideTo(quarterIdx - 1, 0);
                    },
                }
            },
            selectYear: new Date(),
            quarterList: [
                {
                    "year": (new Date()).getFullYear(),
                    "name": "第一季度",
                    "quarter": "1",
                    "months": [1, 2, 3]
                },
                {
                    "year": (new Date()).getFullYear(),
                    "name": "第二季度",
                    "quarter": "2",
                    "months": [4, 5, 6]
                },
                {
                    "year": (new Date()).getFullYear(),
                    "name": "第三季度",
                    "quarter": "3",
                    "months": [7, 8, 9]
                },
                {
                    "year": (new Date()).getFullYear(),
                    "name": "第四季度",
                    "quarter": "4",
                    "months": [10, 11, 12]
                }]
        }
    }, methods: {
        ...mapActions({
            get_my_plans: 'plan/get_my_plans',
            get_plans_by_user: 'plan/get_plans_by_user',
            change_display_plans_params: 'plan/change_display_plans_params',
        }),
        changeYear: function (val) {
            let newDate = new Date(val);
            this.quarterList.forEach((item) => {
                item.year = newDate.getFullYear();
            })

            this.change_display_plans_params({
                'date': newDate,
                'type': 'year'
            })
        },
        selectCurrent: function () {
            let newDate = new Date();
            this.quarterList.forEach((item) => {
                item.year = newDate.getFullYear();
            });
            this.selectYear = newDate;
            let theMonth = newDate.getMonth();
            let quarterIdx = 1;
            if (theMonth <= 3) {
                quarterIdx = 1
            } else if (theMonth <= 6) {
                quarterIdx = 2
            } else if (theMonth <= 9) {
                quarterIdx = 3
            } else if (theMonth <= 12) {
                quarterIdx = 4
            }
            this.toSlide(quarterIdx - 1);
            this.change_display_plans_params({
                'date': newDate,
                'type': 'year'
            })
        },
        toSlide(index) {
            this.$refs.mySwiper.$swiper.slideTo(index, 0)
        },
    },
    computed: {
        ...mapState({
            login_user_name: state => state.loginState.user_info.name,
            login_user_id: state => state.loginState.user_info.id,
            display_plans_params: state => state.plan.display_plans_params,
        }),
        ...mapGetters({
            display_plans: 'plan/display_plans',
        }),
    },
    mounted() {
        if (!this.isOwner) {
            this.get_plans_by_user(this.uid)
        } else {
            this.get_my_plans()
        }
        if (this.display_plans_params['date']) {
            this.changeYear(this.display_plans_params['date'])
        }
    }
}
</script>

<style scoped>

swiper-content {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    margin: 0 auto;
    padding: 50px 0;
}

.view-btn {
    padding: 0;
    text-align: center;
    cursor: pointer;
    border: 1px solid #e1e1e1;
}

.data-btn {
    position: relative;
    border-radius: 3px;
    font-size: 12px;
    height: 28px;
    width: 49px;
    margin-left: 20px;
    margin-right: 10px;
    background-color: #fff;
    border: 1px solid #d7d8d9;
    z-index: 23 \0;
}

div.select-wrap {
    vertical-align: middle;
    background-color: #fff;
    margin-right: 10px;
    color: #000;
    display: inline-block;
    cursor: pointer;
}
</style>